/**
 * Core utilities and shared helpers.
 */
export default function initCore() {}
